import Focus from '../../../../shared/types/enums/focus';
import Pages from '../../../../shared/types/enums/pages';
import TAccess from '../../templates/access';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import { setFocus } from '../../../../shared/store/slices/focus.slice';
import { pushRoute } from '../../../../shared/store/thunks/route.thunk';
import { useAppDispatch, useAppSelector } from '../../../../shared/store/hooks';
import { userSelector } from '../../../../shared/store/slices/user.slice';
import AnalyticsInstance from '@shared/utils/analytics';
import User from '@shared/classes/user';
import AppConfig from '@shared/classes/app';
import { store } from '@shared/store/store';

function SuccessfulLink() {
  const dispatch = useAppDispatch();
  const { email, operator, username, metadata, planId } =
    useAppSelector(userSelector);
  const title = TranslationManager.get('PAGES.ACCESS.SUCCESSFUL_LINK.TITLE');
  const plan = User.getPlan(planId);
  const description = TranslationManager.get(
    'PAGES.ACCESS.SUCCESSFUL_LINK.DESCRIPTION',
    email || '',
    operator?.name || '',
    plan?.name || '',
    username || '',
    metadata?.city || ''
  );
  const buttonText = TranslationManager.get(
    'PAGES.ACCESS.SUCCESSFUL_LINK.BUTTON'
  );
  const action = () => {
    setTimeout(() => {
      const userSlice = store.getState().user;
      const userPlan = User.getPlan(planId);
      if (userSlice.userId) {
        AnalyticsInstance.getOmnitrackManager()?.setUrl(
          AppConfig.getUrl('omnitrack_link')
        );
        if (AnalyticsInstance.getOmnitrackManager()?.session_id) {
          AnalyticsInstance.getOmnitrackManager()?.setLogout();
        }
        if (userSlice.operator?.omnitrack?.active) {
          if (userSlice.token) {
            const customHeaders = { 'X-Access-Token': userSlice.token };
            AnalyticsInstance.getOmnitrackManager()?.setCustomHeaders(
              customHeaders
            );
          }
          AnalyticsInstance.getOmnitrackManager()?.setLogin(
            userSlice.userId || 'Unknown',
            userPlan?.code || 'Unknown',
            userSlice?.operator?.name || ''
          );
        } else {
          AnalyticsInstance.destroy();
        }
      }

      dispatch(setFocus(Focus.MENU));
      dispatch(pushRoute({ route: { Page: Pages.INITIAL, overwrite: true } }));
    });
  };
  return (
    <TAccess
      title={title}
      description={description}
      buttonText={buttonText}
      action={action}
    />
  );
}

export default SuccessfulLink;
